import React, { useContext }from  'react';

import Layout from '../../Layout/index';
import NewsList from '../../NewsList/index';
import NewsContext from '../../../context/news-context';


const Home = () => {
    const { user } = useContext(NewsContext);

    return (
        <Layout title="Home - Bull & Bear">
            <NewsList location={user.location} />
            <NewsList category="world" title="World News" />
        </Layout>
    )
};

export default Home;